module.exports = __webpack_public_path__ + "static/media/ieee-logo-bih.ca4d4b97.png";